module.exports = __webpack_public_path__ + "img/icons_UI_icon_again_black.0924bd4e.svg";